import { motion } from "framer-motion";

export default function ChapterHeading({ num, title, desc, light = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="mb-12 md:mb-16"
    >
      <p
        className={`font-mono text-xs sm:text-sm tracking-[0.35em] uppercase mb-4 ${
          light ? "text-arena" : "text-guinda"
        }`}
      >
        {num}
      </p>
      <h2
        className={`font-serif font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-balance ${
          light ? "text-white" : "text-gris-charcoal"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 max-w-2xl text-base sm:text-lg leading-relaxed ${
            light ? "text-arena" : "text-gris"
          }`}
        >
          {desc}
        </p>
      )}
      <div className={`mt-6 h-px w-24 ${light ? "bg-arena/50" : "bg-guinda/40"}`} />
    </motion.div>
  );
}
